module.exports = __webpack_public_path__ + "img/noData.25e64906.svg";